/*
 * Copyright (c) 2024 CalAmp Corp. All Rights Reserved
 */
export const NAME = 'jobsearchengine';

export const INITIALIZE_JOBS                    = 'INITIALIZE_JOBS';
export const SET_ACTIVE_TAB                     = 'SET_ACTIVE_TAB';
export const ADD_TAB                            = 'ADD_TAB';
export const REMOVE_TAB                         = 'REMOVE_TAB';
export const SET_GRID_COLUMNS                   = 'SET_GRID_COLUMNS';
export const UPDATE_GRID_COLUMNS                = 'UPDATE_GRID_COLUMNS';
export const REFRESH_GRID                       = 'REFRESH_GRID';
export const SET_VIEW_SUB_GROUPS                = 'SET_VIEW_SUB_GROUPS';
export const TOGGLE_FACETS_STATE                = 'TOGGLE_FACETS_STATE';
export const SET_USERNAME_FILTER                = 'SET_USERNAME_FILTER';
export const SET_GRID_PAGE_SIZE                 = 'SET_JOB_SEARCH_ENGINE_GRID_PAGE_SIZE';
export const SET_JOB_TAB_SEARCH                 = 'SET_JOB_TAB_SEARCH';
export const SET_JOBID_DEVICES_FILTER           = 'SET_JOBID_DEVICES_FILTER';
export const JOB_SEARCH_ENGINE_SHOW_ADD_DEVICES = 'JOB_SEARCH_ENGINE_SHOW_ADD_DEVICES';
export const RESET_TABS                         = 'RESET_TABS';
export const RESET_NAME_FILTER                  = 'RESET_NAME_FILTER';
export const SET_TAB_PAGE_SIZE                  = 'SET_JOB_TAB_GRID_PAGE_SIZE';
export const CANCEL_JOB                         = 'CANCEL_JOB';
export const CANCEL_TASK                        = 'CANCEL_TASK';
export const CANCEL_DEVICE                      = 'CANCEL_DEVICE';
export const DISPLAY_RERUN_JOB_DIALOG           = 'DISPLAY_RERUN_JOB_DIALOG';

export const cancelJobs = (job, show = true) => ({
  type : CANCEL_JOB, job, show
});

export const cancelTasks = (job, show = true) => ({
  type : CANCEL_TASK, job, show
});

export const cancelDevices = (job, devicestatus, show = true) => ({
  type : CANCEL_DEVICE, job, devicestatus, show
});

export const displayRerunJobSearchEngineDialog = (job, show = true) => ({
  type : DISPLAY_RERUN_JOB_DIALOG, job, show
});

export const setActiveTab = (tabKey) => ({
  type : SET_ACTIVE_TAB,
  tabKey
});

export const addTab = (tab) => ({
  type : ADD_TAB,
  tab
});

export const removeTab = (tabKey) => ({
  type : REMOVE_TAB,
  tabKey
});

export const showAddDevices = (showAddDevices: boolean = true) => ({
  type : JOB_SEARCH_ENGINE_SHOW_ADD_DEVICES, showAddDevices
});

export const resetInitialTabs = () => ({
  type : RESET_TABS
});

export const resetNameFilter = () => ({
  type : RESET_NAME_FILTER
});

export const setGridColumns = (columnState) => ({
  type : SET_GRID_COLUMNS,
  columnState
});

/**
 * Initialize Jobs
 */
export const initializeJobs = () => {
  return {type: INITIALIZE_JOBS};
};

export const updateGridColumns = (columnState) => ({
  type : UPDATE_GRID_COLUMNS,
  columnState
});

export const refreshGrid = () => ({
  type : REFRESH_GRID
});

export const setJobSearchEngineViewSubGroups = (viewSubGroups: boolean = false) => ({
  type : SET_VIEW_SUB_GROUPS, viewSubGroups
});

export const toggleFacetsState = () => ({
  type : TOGGLE_FACETS_STATE
});

export const setUsernameFilter = (username) => ({
  type : SET_USERNAME_FILTER,
  username
});

export const setJobSearchEngineGridPageSize = (pageSize: number) => ({
  type : SET_GRID_PAGE_SIZE, pageSize
});

export const setJobsTabGridPageSize = (pageSize: number) => ({
  type : SET_TAB_PAGE_SIZE, pageSize
});

export const setJobTabSearch = (filters) => {
  return async(dispatch) => {
    dispatch({type: SET_JOB_TAB_SEARCH, filters});
  };
};

export const setJobIdDevicesFilter = (devices) => {
  return async(dispatch) => {
    dispatch({type: SET_JOBID_DEVICES_FILTER, devices});
  };
};
